var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLatestChats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7121",
    "data-name": "Group 7121",
    transform: "translate(-0.102 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1312",
    "data-name": "Rectangle 1312",
    width: 36,
    height: 36,
    transform: "translate(0.102 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "message-circle",
    d: "M29.136,15.342A12.168,12.168,0,0,1,27.83,20.86a12.342,12.342,0,0,1-11.035,6.824,12.168,12.168,0,0,1-5.518-1.307L3,29.136,5.759,20.86a12.168,12.168,0,0,1-1.307-5.518A12.342,12.342,0,0,1,11.277,4.307,12.168,12.168,0,0,1,16.794,3h.726A12.313,12.313,0,0,1,29.136,14.616Z",
    transform: "translate(1.986 2.329)",
    fill: "none",
    stroke: "#213960",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestChats);
export default __webpack_public_path__ + "static/media/latest-chats.956a7afa003f7467da934d155018e281.svg";
export { ForwardRef as ReactComponent };